import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { AutomationsTableComponent } from '@tv3/containers/automations/automations-table/automations-table.component'
import { AutomationTypes, AutomationViewGroup } from '@tokeet-frontend/automations'
import { DocumentAutomationOverlayService } from '@tv3/containers/documents/automations/automation-overlay/document-automation-overlay.service'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-document-automations',
  templateUrl: './document-automations.component.html',
  styleUrls: ['./document-automations.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DocumentAutomationsComponent implements OnInit {
  @ViewChild(AutomationsTableComponent) table: AutomationsTableComponent

  @Input() showActions = false

  @Input() viewType: 'list' | 'grid' = 'list'
  type = AutomationTypes.Document

  constructor(
    private documentAutomationOverlay: DocumentAutomationOverlayService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit(): void {}

  onAdd() {
    this.amplitudeService.logEvent('document-automations-add')
    this.documentAutomationOverlay.open()
  }

  onEdit(automation: AutomationViewGroup) {
    this.amplitudeService.logEvent('document-automations-edit')
    this.documentAutomationOverlay.open(automation)
  }

  onDuplicate(automation: AutomationViewGroup) {
    this.amplitudeService.logEvent('document-automations-duplicate')
    this.documentAutomationOverlay.open(automation, true)
  }
}
